// formのsubmitボタンの連打防止
// form要素に.prevent-double-submitクラスを付与すると、submit時にボタンが無効化される

export default class PreventDoubleSubmit {
  constructor() {
    document.addEventListener('DOMContentLoaded', this.preventDoubleSubmit);
  }

  preventDoubleSubmit() {
    const targets = Array.from(document.getElementsByClassName('prevent-double-submit'));
    targets.forEach((target) => {
      target.addEventListener('submit', () => {
        const submitButton = target.querySelector('input[type="submit"]');
        submitButton.style.cursor = 'default';
        submitButton.setAttribute('disabled', true);
      });
    });
  }
}
